import { Box } from '@mui/joy';

import { BomPartViewByType } from 'bom/enums';
import { IJob } from 'jobs/types';

import { ElementList } from './ElementList';
import { PartList } from './PartList';
import { useViewByContext, ViewByProvider } from './ViewBy';

interface IProps {
  job: IJob;
}

export const MaterialList = ({ job }: IProps) => {
  return (
    <ViewByProvider>
      <Table job={job} />
    </ViewByProvider>
  );
};

const Table = ({ job }: IProps) => {
  const { viewBy } = useViewByContext();

  return (
    <Box sx={{ height: '100%' }}>
      {viewBy === BomPartViewByType.PART && <PartList job={job} />}
      {viewBy === BomPartViewByType.ELEMENT && <ElementList job={job} />}
    </Box>
  );
};
